import ActiveTest from "@/components/shared/ActiveTest";
import NetworkTest from "@/components/shared/NetworkTest";
import NotificationTest from "@/components/shared/NotificationTest";
import { userNamespace } from "@/store/modules/user";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: { ActiveTest, NetworkTest, NotificationTest }
})
export default class Verification extends Vue {
  @Getter("demo", userNamespace)
  demo!: boolean;
}
